import { HTMLProps } from "react";

import MinervaLogo from "../../assets/minerva_logo_8x.png";

export const MinervaLogoIcon = ({ ...imgProps }: HTMLProps<HTMLImageElement>) => (
  <img alt="Institution Logo" height="32" src={MinervaLogo as string} width="32" {...imgProps} />
);
